import type { ComponentType, ReactNode } from 'react';
import { useSession } from './context/Session';
import type React from 'react';

export interface RolesProps {
  authorizedRoles: string[];
  defaultAction?: () => React.JSX.Element | ReactNode | null;
}

export const withRole =
  (props: RolesProps) =>
  <T extends object>(WrappedComponent: ComponentType<T>) => {
    return (innerProps: T) => {
      const { userInfo } = useSession();
      const isAuthorized =
        userInfo?.roleType &&
        props.authorizedRoles?.map((r) => r.toLowerCase()).includes(userInfo.roleType.toLowerCase());
      if (!isAuthorized) {
        if (props.defaultAction) {
          return props.defaultAction();
        }
        return <></>;
      }
      return <WrappedComponent {...innerProps} />;
    };
  };
